/**
 * @author caijianjia
 * @date 2020/4/3 7:54 下午
 */
export const fieldsImport = [
    {
        attr: 'type',
        "name": "单项选择",
        "value": "",
        "type": "RadioGroup",
        "props": {
            "rules": {
                "required": true,
                "message": "请选择"
            },
            "border": true
        },
        "options": [
            {
                "key": "1",
                "value": "智能配音"
            },
            {
                "key": "2",
                "value": "我要录制"
            },
            {
                "key": "3",
                "value": "导入配音"
            }
        ]
    },
    {
        attr: 'btns',
        "name": "",
        "value": "",
        "type": "Btns",
        "props": {
            type: 'small',
            "rules": {
                "required": false,
                "message": "请选择"
            }
        },
        "options": [
            {
                "key": "local",
                "value": "从本地上传音频"
            },
            {
                "key": "select",
                "value": "素材库选择音频"
            }
        ]
    },
    {
        attr: 'voice',
        "name": "说话声音选择",
        "value": "",
        "type": "WordEditIcon",
        "props": {
            "placeholder": "请输入",
            "rules": {
                "required": true,
                "message": "请输入",
                "target": "blur"
            },
            icon: 'headset'
        },
        options: [
            {key: '1', value: '小宇'},
            {key: '0', value: '小美'},
            {key: '3', value: '逍遥'},
            {key: '4', value: '丫丫'},
            {key: '106', value: '博文'},
            {key: '110', value: '小童'},
            {key: '111', value: '小萌'},
            {key: '103', value: '米朵'},
            {key: '5', value: '小娇'}
        ]
    },
    {
        "attr": "text",
        "name": "说话文本",
        "value": "",
        "type": "Input",
        "props": {
            "placeholder": "请输入",
            "rules": {
                "required": false,
                "message": "请输入",
                "target": "blur"
            },
            "type": "textarea",
            "rows": "2"
        }
    },
    {
        attr: 'isShow',
        "name": "显示文本",
        "value": false,
        "type": "Switch",
        "props": {
            "rules": {
                "required": false,
                "message": "请选择"
            },
            "border": true
        },
        "options": [
            {
                "key": "1",
                "value": "显示文本"
            }
        ]
    },
    // {
    //     attr: 'img',
    //     "name": "文本框选择",
    //     "value": "",
    //     "type": "UploadSingleTencent",
    //     "props": {
    //         "rules": {
    //             "required": true,
    //             "message": "请选择",
    //             "target": "blur"
    //         }
    //     },
    //     "status": "1"
    // }
]
